import { render, staticRenderFns } from "./Zaloga.vue?vue&type=template&id=fcf22d24&"
import script from "./Zaloga.vue?vue&type=script&lang=js&"
export * from "./Zaloga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports